import React, { Component } from "react";
import { Redirect, Link, NavLink } from "react-router-dom";
import $ from "jquery";
import Cookies from "universal-cookie";
import API from "../../../utils/API";
import { Api } from "../../../utils/Variables";
import { getCookieField, capitalizeFirst, makeUrl } from "../../../utils";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      titles: [],
      groupTitles: [],
      reportTitles: [],
    };
  }

  componentDidMount() {
    this.loadSsrMenus();
  }

  loadSsrMenus() {
    try {
      this.setState({ showLoader: true });
      var form = new FormData();

      //form.append("type", this.props.type);
      API.post("site/v1/ssr/menus", form).then((res) => {
        if (res["data"].status == "1") {
          this.setState({
            titles: res["data"].titles,
            groupTitles: res["data"].grouptitles,
            reportTitles: res["data"].reporttitles,
            showLoader: false,
          });
        } else {
          this.setState({ showLoader: false });
        }
      });
    } catch (error) {
      this.setState({ showLoader: false });
    }
  }

  getReportTitle(titleId, groupId) {
    try {
      var d = this.state.reportTitles.filter(function (obj) {
        return obj.criteria_id == titleId && obj.criteria_group_id == groupId;
      });
      var rv = [];
      /*<NavLink
              className="nav-link"
              to={
                "/" + item.report_type + "/" + item.id + "/" + item.report_code
              }
              activeClassName="report_menu_active"
            >
              {item.report_code}.{item.report_title}
            </NavLink>*/

      d.map((item, i) => {
        rv.push(
          <li className="nav-item ssr-menu_report_title">
            <NavLink
              className="nav-link"
              to={"/" + item.id + "/" + item.report_code}
              activeClassName="report_menu_active"
            >
              {item.report_code}.{item.report_title}
            </NavLink>
          </li>
        );
      });

      return rv;
    } catch (error) {}
  }

  getGroupTitle(titleId) {
    try {
      var d = this.state.groupTitles.filter(function (obj) {
        return obj.criteria_id == titleId;
      });
      var rv = [];

      d.map((item, i) => {
        var index = this.state.reportTitles.findIndex(function (obj) {
          return obj.criteria_group_id == item.id;
        });
        if (index > -1) {
          rv.push(
            <li className="nav-item ssr-menu_group_title">
              <a className="nav-link" href="javascript:;">
                {item.criteria_group_code}.{item.criteria_group_title}
              </a>
              <ul className="ssr-reporttitle-menu">
                {this.getReportTitle(titleId, item.id)}
              </ul>
            </li>
          );
        }
      });

      return rv;
    } catch (error) {}
  }

  render() {
    return (
      <nav className="col-md-3 d-none d-md-block bg-light sidebar">
        <div className="sidebar-sticky">
          <ul className="nav flex-column">
            {this.state.titles.map((title, key) => {
              return (
                <li className="nav-item ssr-menu_title">
                  <a className="nav-link" href="javascript:;">
                    <span data-feather="home"></span>
                    {title.criteria_code}.{title.criteria_title}
                  </a>
                  <ul className="ssr-grouptitle-menu">
                    {this.getGroupTitle(title.id)}
                  </ul>
                </li>
              );
            })}
          </ul>
        </div>
      </nav>
    );
  }
}
export default Sidebar;
